import Button from '@/components/Button';
import Header from '@/components/Header';

type ResolveDraftStatusProps = {
	onCancel?: () => void;
};

export default function ResolveDraftStatus({
	onCancel = () => {}
}: ResolveDraftStatusProps ) {
	return (
		<div>
			<Header element="h2">There are currently forms in Draft status.</Header>

			<p className="mb-4">Please review and save the forms before printing.</p>

			<Button type="button" variant="primary" size="medium" onClick={ onCancel }>OK</Button>
		</div>
	);
}
